import { z } from "zod";
import { SourceDocumentSchema } from "./sourceDocument";

export const CustomXmlPartSchema = z.object({
  id: z.string(),
  createdAt: z.string(),
  type: z.string(),
  value: z.string(),
  source_document: SourceDocumentSchema.optional().nullable(),
  metadata: z
    .object({
      source_row_id: z.string().optional().nullable(),
      check_id: z.string().optional().nullable(),
    })
    .optional()
    .nullable(),
  test_result: z
    .object({
      eval_column_id: z.string().nullable(),
      check_id: z.string().nullable(),
      session_id: z.string(),
      sample_id: z.string(),
    })
    .optional()
    .nullable(),
});

export type CustomXmlPart = z.infer<typeof CustomXmlPartSchema>;
